export {default} from 'mapbox-gl';
